import { useCompanyStore } from "../../state/useCompanyStore";
import { useGetPaymentCurrencyList } from "../../utils";

export const validateCreateService = ({
  name,
  duration,
  description,
  price,
  userLocalCurrency,
  userCountry
}: any) => {
  const errors = {
    name: "",
    duration: "",
    description: "",
    charge: { [userLocalCurrency]: "", [userCountry]: "", GBP: "" },
  };

  if (!name) {
    errors.name = "Service Name is required";
  }

  const servicePrice = price.find((p: any) => p.currency === userLocalCurrency);
  const servicePriceUSD = price.find((p: any) => p.currency === userCountry);
  const servicePriceGBP = price.find((p: any) => p.currency === "GBP");

  if (servicePrice) {
    if (servicePrice.amount <= 0) {
      errors.charge[userLocalCurrency] = "amount must be greater than 0";
    }
  }
  if (servicePriceUSD) {
    if (servicePriceUSD.amount === 0) {
      errors.charge[userCountry] = "amount must be greater than 0";
    }
  }
  if (servicePriceGBP) {
    if (servicePriceGBP.amount === 0) {
      errors.charge.GBP = "amount must be greater than 0";
    }
  }

  if (!servicePrice) {
    errors.charge[userLocalCurrency] = "Service charge is required";
  }
  const hasErrors = Object.values(errors).some((error) => {
    if (typeof error === "object") {
      // Check for nested errors
      return Object.values(error).some((nestedError) => nestedError !== "");
    }
    return error !== "";
  });

  return { hasErrors, errors };
};
export const validateEditService = ({
  name,
  duration,
  description,
  price,
  userLocalCurrency,
  userCountry
}: any) => {
  const errors = {
    name: "",
    duration: "",
    description: "",
    charge: { [userLocalCurrency]: "", [userCountry]: "", GBP: "" },
  };

  if (!name) {
    errors.name = "Service Name is required";
  }

  const servicePrice = price.find((p: any) => p.currency === userLocalCurrency);
  const servicePriceUSD = price.find((p: any) => p.currency === userCountry);
  const servicePriceGBP = price.find((p: any) => p.currency === "GBP");

  if (servicePrice) {
    if (servicePrice.amount <= 0) {
      errors.charge[userLocalCurrency] = "amount must be greater than 0";
    }
  }
  if (servicePriceUSD) {
    if (servicePriceUSD.amount === 0) {
      errors.charge[userCountry] = "amount must be greater than 0";
    }
  }
  if (servicePriceGBP) {
    if (servicePriceGBP.amount === 0) {
      errors.charge.GBP = "amount must be greater than 0";
    }
  }

  if (!servicePrice) {
    errors.charge[userLocalCurrency] = "Service charge is required";
  }

  const hasErrors = Object.values(errors).some((error) => {
    if (typeof error === "object") {
      // Check for nested errors
      return Object.values(error).some((nestedError) => nestedError !== "");
    }
    return error !== "";
  });

  return { hasErrors, errors };
};
